import React, { useState, useContext, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom"
import "../styles/style.css"
import { api_domain } from "../config"
import Menu from "../components/navbar.js";
import { AuthContext } from "../components/AuthContext";

export function Login() {
  const context = useContext(AuthContext);
  const { authenticated, setAuthenticated, basicHttpAuthString, setBasicHttpAuthString } = context;

  const navigate = useNavigate();

  // check if we are actually already logged in, if so, redirect away
  useEffect(() => {
    if (authenticated) {
    	navigate("/");
    }
  }, []);

  const authSuccess = (authString) => {
    setAuthenticated(true);
    setBasicHttpAuthString(authString);
    navigate("/");
  }

  const handleLogin = (event) => {
    event.preventDefault();
    const formData = new FormData(event.target),
      formDataObj = Object.fromEntries(formData.entries());

    const authString = `Basic ${btoa(`${formDataObj.username}:${formDataObj.password}`)}`;

    fetch(`${api_domain}/basicAuthLogin`, {
      method: "GET",
      headers: {
        Authorization: `${authString}`
      }
    }).then((response) => response.ok ? authSuccess(authString): alert("Invalid credentials"));
  }

  return (

    <div className="container">
    <Menu/>
    {/*<script>{menuFunction()}</script>*/}
    <div className="tools">
        <div className="titleMain">Login</div>

	  <form className="searchForm" onSubmit={handleLogin}>

      {/*-------------------------------------------------------------*/}
        <div className="searchRow">
          <input
            name="username"
            type="text"
            className="searchFieldOne"
            placeholder="Username"
          /><br></br>
	  <input
            name="password"
            type="password"
            className="searchFieldOne"
            placeholder="Password"
          /><br></br>
          <button className="buttonSearch" variant="primary" type="submit">Login</button>
        </div>

	  </form>

   </div>
   </div>
  );
}

